import React from "react";
import InvoicePreviewContent from "../components/trips/preview-invoice-content";
const InvoicePreview = () => {
  return <InvoicePreviewContent />;
};

export default InvoicePreview;
